export default __webpack_public_path__ + "static/media/fishes-smm.104407e5.svg";